<div class="file-section">
    <div class="actions">
        <h4>{{ title }}</h4>
        <!-- Camera button if enabled -->
        <button mat-icon-button *ngIf="cameraEnabled" (click)="triggerCamera()" class="camera-button">
            <mat-icon class="m-r-10">photo_camera</mat-icon>
        </button>
    </div>

    <div class="file-upload" (click)="!fileObjects.length || allowMultiple ? fileInput.click() : null"
        (drop)="onFileDrop($event)" (dragover)="onFileDragOver($event)" [class.has-file]="fileObjects.length"
        [class.hover]="fileHover" (mouseenter)="fileHover = true" (mouseleave)="fileHover = false">

        <input type="file" #fileInput (change)="onFileUpload($event)" [multiple]="allowMultiple" style="display: none;"
            [accept]="allowedFileTypes">

        <!-- Show placeholder if no files or preview image is present -->
        <div *ngIf="!fileObjects.length && !previewImage" class="placeholder-text">
            Drag and drop {{ allowedFileTypes }} or click to upload
        </div>

        <!-- If preview mode is enabled and an image is present, show the preview and controls -->
        <div *ngIf="previewEnabled && previewImage" class="preview-container"
            >
            <img [src]="previewImage" [style.transform]="'rotate(' + rotation + 'deg)'" alt="Preview Image"
                class="preview-img">
            <div class="preview-controls">
                <button type="button" mat-icon-button (click)="rotateLeft($event)" matTooltip="Rotate Left">
                    <mat-icon>rotate_left</mat-icon>
                </button>
                <button type="button" mat-icon-button (click)="rotateRight($event)" matTooltip="Rotate Right">
                    <mat-icon>rotate_right</mat-icon>
                </button>
                <button type="button" mat-icon-button (click)="retakeImage($event)" matTooltip="Retake Image">
                    <mat-icon>restore</mat-icon>
                </button>
                <button type="button" mat-icon-button color="primary" (click)="confirmImage($event)"
                    matTooltip="Confirm Upload">
                    <mat-icon>check</mat-icon>
                </button>
            </div>
        </div>


        <!-- Show file gallery when preview is disabled -->
        <app-file-gallery [fileObjects]="fileObjects" (fileRemove)="removeFile($event)" (transformedFiles)="handleTransformedFiles($event)"
            *ngIf="!previewEnabled && showGallery" [enableEditing]="enableEditing"></app-file-gallery>
    </div>

    <p class="hint">{{ hintMessage }}</p>
</div>